<div class="profile-container">
  <div class="">
    <div class="profile-content">
      <!-- <button class="add-ticket" data-toggle="modal" data-target="#exampleModal">Add Param</button>
        <div class="personal-details">
            <h4 class="personal-details-title">Params List</h4>
            <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Param Name</th>
                  <th scope="col">Param Type</th>
                  <th scope="col">Action</th>
                  
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let param of paramData | paginate : {
                  itemsPerPage: tableSize,
                  currentPage: page,
                  totalItems: count
                  };let i = index">
                  <th scope="col">{{i+1}}</th>
                  <th scope="col">{{param.name}}</th>
                  <th scope="col">{{param.type}}</th>
                  <th scope="col">
                    <svg xmlns="http://www.w3.org/2000/svg" (click)="getParamById(param.predefinedParameterId)" data-toggle="modal" data-target="#viewModal"   width="18" height="18" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
                      <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                      <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                    </svg>
                  </th>
                </tr>
                    
              </tbody>
          </table>
          <div class="pagination-block" *ngIf="paramData.length != 0">
            <pagination-controls
              previousLabel="Prev"
              nextLabel="Next"
              (pageChange)="onTableDataChange($event)"
            >
            </pagination-controls>
        </div>

        </div> -->

      <div class="personal-details">

        <div class="header-block">
          <div class="header-title">
            <p>Params List</p>
          </div>
          <div class="add-block">
            <div class="search">
              <form autocomplete="off">
                <!-- <i class="bi bi-x-lg"></i> -->
                <input type="text" [ngModelOptions]="{standalone: true}" placeholder="search product"
                  [(ngModel)]="searchKey">
              </form>
              <i class="bi bi-x-lg" (click)="refreshSearch()" *ngIf="searchKey != ''"></i>

              <i class="bi bi-search" (click)="getPredefinedParameterByWildSearch(0,10)"></i>
            </div>
            <button *ngIf="actionControls.isAdd" data-toggle="modal" data-target="#exampleModal"><i
                class="bi bi-plus-lg"></i> Add</button>
          </div>
        </div>

        <table class="table table-striped">
          <thead>
            <tr>
              <th style="width: 40%;">Param Name</th>
              <th style="width: 40%;">Param Type</th>
              <th style="width: 20%;text-align: center;">Action</th>
            </tr>
          </thead>
        </table>
        <div *ngIf="!isLoading">
          <div class="data-view" *ngFor="let param of paramData | paginate : {
              itemsPerPage: tableSize,
              currentPage: pageNumber,
              totalItems: totalRecords
              }  let i = index">

            <p style="width: 40%;">{{param.name}}</p>
            <p style="width: 40%;">{{param.type}}</p>
            <p class="action-buttons" style="width: 20%;padding-left: 15px;">
              <i *ngIf="actionControls.isModify" (click)="getParamById1(param.predefinedParameterId)"
                data-toggle="modal" data-target="#updateModal" class="bi bi-pencil-square"></i>
              <i *ngIf="actionControls.isView" (click)="getParamById(param.predefinedParameterId)" data-toggle="modal"
                data-target="#viewModal" class="bi bi-eye-fill"></i>
              <i (click)="del(param.id)" data-toggle="modal" data-target="#deleteModal" class="bi bi-trash3"></i>
            </p>
          </div>
        </div>



        <div class="loader" *ngIf="isLoading">
          <div class="spinner"></div>
        </div>

        <div class="loader" *ngIf="!isLoading && paramData.length == 0">
          <div class="no-data">
            <img src="assets/no-data-6.png" alt="">
            <p>no data found</p>
          </div>

        </div>

        <div class="paginator">
          <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize"
            [totalRecords]="totalRecords" [showFirstLastIcon]="false" [showCurrentPageReport]="true"
            currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
        </div>

      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Add Param
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">

        <div>

          <div [formGroup]="form">
            <div class="row">
              <div class="col-md-6 col-lg-6">
                <div class="form-group">
                  <label>Param Type</label>
                  <select name="" id="" formControlName="type" class="form-control">
                    <option value="" disabled selected hidden>--- select type ---</option>
                    <option value="{{param}}" *ngFor="let param of paramTypes">{{param}}</option>
                  </select>
                  <span class="err" *ngIf="form.get('type').invalid && formSubmit">param type required</span>
                </div>
              </div>
              <div class="col-md-6 col-lg-6">
                <div class="form-group">
                  <label>Param Name</label>
                  <input formControlName="name" type="text" class="form-control">
                  <span class="err" *ngIf="form.get('name').invalid && formSubmit">param type required</span>
                </div>
              </div>

              <div class="col-md-6 col-lg-6">
                <div class="form-group">
                  <label>Box Type</label>
                  <select name="" id="" (change)="boxTypeChange()" formControlName="boxType" class="form-control">
                    <option value="" disabled selected hidden>--- select type ---</option>
                    <option value="{{type}}" *ngFor="let type of type">{{type}}</option>
                  </select>
                </div>
              </div>

              <div class="col-md-6 col-lg-6">
                <div class="form-group">
                  <label>Required</label>
                  <select name="" id="" formControlName="isMandatory" class="form-control">
                    <option value="" disabled selected hidden>--- select required ---</option>
                    <option value="false">No</option>
                    <option value="true">Yes</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-6" *ngIf="form.get('boxType').value == 'Dropdown'">
              <div class="form-group">
                <label>Dropdown Type</label>
                <select name="" id="" (change)="dropdownChange()" formControlName="DropdownType" class="form-control">
                  <option value="" disabled selected hidden>--- select type ---</option>
                  <option value="Enter Manual">Enter Manual</option>
                  <option value="Select From Data">Select From Data</option>
                </select>
              </div>
            </div>

            <div class="col-md-6 col-lg-6" *ngIf="form.get('DropdownType').value == 'Select From Data'">
              <div class="form-group">
                <label>Dropdown Data</label>
                <select name="" id="" formControlName="api" class="form-control">
                  <option value="" disabled selected hidden>--- select type ---</option>
                  <option value="{{list.apiLink}}" *ngFor="let list of dynamicData">{{list.apiName}}</option>

                </select>
              </div>
            </div>

            <div formArrayName="possibleValue" *ngIf="form.get('DropdownType').value == 'Enter Manual'">
              <div *ngFor="let object of form.controls.possibleValue['controls'];let i = index;let last = last"
                [formGroupName]="i">
                <div class="row">
                  <div class="col-md-10 col-lg-10">
                    <div class="form-group">
                      <input formControlName="key" placeholder="enter possiblevalue" type="text" class="form-control">
                    </div>
                    <span class="err" *ngIf="paramArr.controls[i].get('key')?.invalid && formSubmit">key required</span>

                  </div>
                  <div class="col-md-2 col-lg-2 paramBtn" *ngIf="last">
                    <svg xmlns="http://www.w3.org/2000/svg" (click)="addpossibleValue()" fill="currentColor"
                      class="bi bi-plus-circle" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                      <path
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" *ngIf="i!=0" (click)="removepossibleValue(i)"
                      fill="currentColor" class="bi bi-dash-circle" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                      <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                    </svg>
                  </div>
                  <div class="col-md-2 col-lg-2 paramBtn1" *ngIf="!last">
                    <svg xmlns="http://www.w3.org/2000/svg" (click)="removepossibleValue(i)" fill="currentColor"
                      class="bi bi-dash-circle" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                      <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

          </div>


          <div class="modal-footer">
            <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
            <button type="button" (click)="addParam()" class="btn btn-primary">Add Param</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<div class="modal fade" id="viewModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Param List
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div *ngFor="let param of singleParam">
          <div class="row">
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Param Name</label>
                <input value="{{param.name}}" readonly type="text" class="form-control">
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Param Type</label>
                <input value="{{param.type}}" readonly type="text" class="form-control">
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Box Type</label>
                <input value="{{param.boxType}}" readonly type="text" class="form-control">
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Mandatory</label>
                <input value="{{param.isMandatory}}" readonly type="text" class="form-control">
              </div>
            </div>
          </div>



          <div class="row" *ngIf="param.possibleValue.length != 0">
            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label for="" style="display: flex;text-align: center;justify-content: center;">Possible Value</label>
              </div>
            </div>
            <div class="col-md-6 col-lg-6" *ngFor="let possibleValue of param.possibleValue">
              <div class="form-group">
                <input value="{{possibleValue}}" readonly type="text" class="form-control">
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteModalLabel">Confirmation!!
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <p>are you sure? want to delete??</p>
        <div class="modal-footer">
          <button type="button" id="closeModalButton1" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button type="button" (click)="deleteParam()" class="btn btn-primary">Delete</button>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="updateModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">UPDATE PARAM
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">

        <div [formGroup]="form">
          <div class="row">
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Param Type</label>
                <select name="" id="" formControlName="type" class="form-control">
                  <option value="" disabled selected hidden>--- select type ---</option>
                  <option value="{{param}}" *ngFor="let param of paramTypes">{{param}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Param Name</label>
                <input formControlName="name" type="text" class="form-control">
              </div>
            </div>

            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Box Type</label>
                <select name="" id="" (change)="boxTypeChange()" formControlName="boxType" class="form-control">
                  <option value="" disabled selected hidden>--- select type ---</option>
                  <option value="{{type}}" *ngFor="let type of type">{{type}}</option>
                </select>
              </div>
            </div>

            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Required</label>
                <select name="" id="" formControlName="isMandatory" class="form-control">
                  <option value="" disabled selected hidden>--- select required ---</option>
                  <option value="false">No</option>
                  <option value="true">Yes</option>
                </select>
              </div>
            </div>
          </div>


          <div formArrayName="possibleValue" *ngIf="form.get('boxType').value == 'Dropdown'">
            <div *ngFor="let object of form.controls.possibleValue['controls'];let i = index;let last = last"
              [formGroupName]="i">
              <div class="row">
                <div class="col-md-10 col-lg-10">
                  <div class="form-group">
                    <input formControlName="key" placeholder="enter possiblevalue" type="text" class="form-control">
                  </div>
                </div>
                <div class="col-md-2 col-lg-2 paramBtn" *ngIf="last">
                  <svg xmlns="http://www.w3.org/2000/svg" (click)="addpossibleValue()" fill="currentColor"
                    class="bi bi-plus-circle" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path
                      d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" *ngIf="i!=0" (click)="removepossibleValue(i)"
                    fill="currentColor" class="bi bi-dash-circle" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                  </svg>
                </div>
                <div class="col-md-2 col-lg-2 paramBtn1" *ngIf="!last">
                  <svg xmlns="http://www.w3.org/2000/svg" (click)="removepossibleValue(i)" fill="currentColor"
                    class="bi bi-dash-circle" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                  </svg>
                </div>
              </div>
            </div>
          </div>

        </div>


        <div class="modal-footer">
          <button type="button" id="closeModalButton3" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button type="button" (click)="updateParam()" class="btn btn-primary">save changes</button>
        </div>
      </div>
    </div>
  </div>
</div>